import React from "react";
import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionLabel({ children, testId }) {
  return (
    <div className="flex items-center gap-4" data-testid={testId}>
      <span className="h-px w-8 bg-gold" />
      <span className="eyebrow">{children}</span>
    </div>
  );
}

export function SerifHeading({ children, className = "", as: As = "h2" }) {
  return (
    <As
      className={`display text-4xl md:text-5xl lg:text-6xl ${className}`}
    >
      {children}
    </As>
  );
}
